module.exports = __webpack_public_path__ + "img/4.f05da857.jpg";